import store from '@/store';
import { generateDispatchActions as generateBase } from './base';
import { generateDispatchActions as generateUserAutarkyStatus } from './userAutarkyStatus';
import { generateDispatchActions as generateUserCreditStatus } from './userCreditStatus';
import { generateDispatchActions as generateUserProfileProgress } from './userProfileProgress';
import { generateDispatchActions as generateTempAmount } from './tempAmount';

export const dispatchActions = {
  /** 基础共用状态 */
  base: generateBase(store),
  /** 用户自营状态 */
  userAutarkyStatus: generateUserAutarkyStatus(store),
  /** 用户授信状态 */
  userCreditStatus: generateUserCreditStatus(store),
  /** 用户资料填写进度 */
  userProfileProgress: generateUserProfileProgress(store),
  /** 临额下发 */
  tempAmount: generateTempAmount(),
};
